import { Tab } from '@mui/material';
import {
  EstadosContratoChoiceEnum,
  a11yProps,
  useTabsFormOnly,
} from '@/shared';
import {
  CustomTabPanel,
  FormTabsOnly,
  SingleBoxTableTabsOnly,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import { PermissionsEnum } from '@/auth/interfaces';
import { EstadosAgendamientoEnumChoice } from '@/shared';
import { useFetchAgendamientos } from '@/shared/actions/erp';
import { GeneralTable, TableTabsScene } from '@/shared/components/ui';
import {
  useCheckPermissions,
  useTableServerSideFiltering,
} from '@/shared/hooks';
import { useTableFilter } from '@/shared/hooks/useTableFilter';
import { Agendamiento } from '@/shared/interfaces';
import { useColumnsAgendamientos } from '../../../shared/hooks';



const AgendamientosFinalizadosPyL: React.FC= () => {
  useCheckPermissions(PermissionsEnum.api_view_agendamiento);
  const { handleMethodChange, valueTab } = useTabsFormOnly({});

  
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: agendamientosPagingRes,
    isLoading,
    isRefetching,
  } = useFetchAgendamientos({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      identificacion: searchTerm,
      ...filterObject,
      filterByState: false,
      estado_agendamiento_in: `${EstadosAgendamientoEnumChoice.FINALIZADO},${EstadosAgendamientoEnumChoice.RECORDINADO}`,
      contrato_estado_contrato: EstadosContratoChoiceEnum.ACTIVO
    },
  });

  ///* columns
  const { 
    agendamientosAprobados
  } = useColumnsAgendamientos();


  


  return (
    <SingleTableBoxScene title={'Agendamientos Finalizados'}>
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="Todos" value={1} {...a11yProps(1)} />
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

      {/* ============ Agendamiento Finalizados ============ */}
      <CustomTabPanel value={valueTab} index={1}>
        <TableTabsScene
          globalFilter={globalFilter}
          onChangeFilter={onChangeFilter}
          searchInputText="por identificación"
          //onChangeRangeDate={onChangeRangeDate}
          cleanFilter={cleanFilter}
        >
          <GeneralTable<Agendamiento>
            columns={agendamientosAprobados}
            data={agendamientosPagingRes?.data?.data || []}
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            // // search
            enableGlobalFilter={false}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={agendamientosPagingRes?.data?.count}
            // // // actions ========
            enableColumnActions={false}
            enableEditing={false}
            canDelete={false}
            />
        </TableTabsScene>
      </CustomTabPanel>

    </SingleTableBoxScene>

  );
};

export default AgendamientosFinalizadosPyL;
